(function () {
  const BASE = "https://home.brindlechute.com";

  function isBrindleBookingUrl(url) {
    try {
      const u = new URL(url, window.location.href);
      return (
        u.origin === BASE &&
        /^\/c\/newbooking\/\d+\/(group(\/\d+)?|detail\/\d+)/.test(u.pathname)
      );
    } catch (e) {
      return false;
    }
  }

  function initCore() {
    if (window.brindlechute) return;

    const css = document.createElement("style");
    css.textContent = `
      .brindle-main{
        z-index:999999;
        position:fixed;
        inset:0;
        opacity:0;
        transition:.25s;
      }
      .brindle-main.open{
        opacity:1;
      }
      .brindle-main-content{
        position:fixed;
        top:40px;
        left:max(50% - 640px,40px);
        width:calc(100% - 80px);
        height:calc(100% - 80px);
        max-width:1280px;
        background:#fff;
        border-radius:6px;
        overflow:hidden;
      }
      .brindle-main-content iframe{
        width:100%;
        height:100%;
        border:0;
      }
      .brindle-main-mask{
        position:fixed;
        inset:0;
        background:#000;
        opacity:.55;
      }
      @media (max-width:768px){
        .brindle-main-content{
          top:0;
          left:0;
          width:100%;
          height:100%;
          border-radius:0;
        }
      }
    `;
    document.head.appendChild(css);

    let modal = null;
    let iframe = null;

    function close() {
      if (!modal) return;

      try {
        if (iframe) iframe.src = "about:blank";
      } catch (e) {}

      modal.classList.remove("open");

      setTimeout(() => {
        if (modal) modal.remove();
        modal = null;
        iframe = null;
      }, 200);
    }

    function open(url) {
      if (modal) close();

      const wrap = document.createElement("div");
      wrap.className = "brindle-main-content";

      iframe = document.createElement("iframe");
      iframe.allow = "payment";
      iframe.src = "about:blank";

      const mask = document.createElement("div");
      mask.className = "brindle-main-mask";
      mask.onclick = close;

      wrap.appendChild(iframe);

      modal = document.createElement("div");
      modal.className = "brindle-main";
      modal.appendChild(mask);
      modal.appendChild(wrap);
      document.body.appendChild(modal);

      setTimeout(() => {
        iframe.src = url;
        modal.classList.add("open");
      }, 0);
    }

    window.addEventListener("message", function (ev) {
      if (ev.origin !== BASE) return;
      const d = ev.data;
      if ((d && typeof d === "object" && d.type === "closeModal") || d === "closeModal") {
        close();
      }
    });

    window.brindlechute = {
      openUrl: open,
      close: close
    };
  }

  initCore();

  document.addEventListener("click", function (e) {
    const link = e.target.closest("a[href]");
    if (!link) return;

    const href = link.getAttribute("href");
    if (!href) return;

    const fullUrl = new URL(href, window.location.href).href;

    if (!isBrindleBookingUrl(fullUrl)) return;

    e.preventDefault();
    e.stopPropagation();

    window.brindlechute.openUrl(fullUrl);
  }, true);
})();